import lang from '../../../lib/language';

import ImageEmpty from '../../../assets/img/image_empty.svg';

import styles from './ErrorContent.module.scss';

type Props = {
  tabTitle: string;
};

const ErrorContent = ({ tabTitle }: Props) => {
  const content = (
    <>
      <p className={styles.description}>
        {lang.commonMyAccountNoStocksMessage1()}
        {lang.commonMyAccountNoStocksMessage2()}
      </p>
    </>
  );

  return (
    <div className={styles.wrapperNoStocks}>
      <img src={ImageEmpty} alt="no messages logo" />
      {tabTitle.length > 0 && <p className={styles.title}>{tabTitle}</p>}
      {content}
    </div>
  );
};

export default ErrorContent;
